import { render, staticRenderFns } from "./AccountIndex.vue?vue&type=template&id=de84e390&scoped=true&"
import script from "./AccountIndex.vue?vue&type=script&lang=js&"
export * from "./AccountIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de84e390",
  null
  
)

export default component.exports